import type { ClientTheme } from "@/app/lib/themes"

interface TableColumnHeaderProps {
  label: string
  theme: ClientTheme
}

export function TableColumnHeader({ label, theme }: TableColumnHeaderProps) {
  return (
    <span
      style={{
        fontFamily: "var(--font-ui)",
        fontSize: "10px",
        fontWeight: 600,
        color: theme.textMuted,
        textTransform: "uppercase" as const,
        letterSpacing: "0.05em",
      }}
    >
      {label}
    </span>
  )
}
